import { useState } from 'react';

import Metrics from '../services/metrics';
export function useMetrics(allowUnauthenticated?: boolean) {
  const [logger] = useState(
    allowUnauthenticated ? Metrics.getLoggerUnauthenticated() : Metrics.getLogger(),
  );
  return logger;
}
